import React, { useMemo } from 'react';
import { Locale } from '@yi/core';
import { i18n_start_your_free_trial_to_watch } from '@yi/i18n/phrases/i18n_start_your_free_trial_to_watch';
import { i18n_try_free_for_x_days } from '@yi/i18n/phrases/i18n_try_free_for_x_days';
import { i18n_want_to_watch_series } from '@yi/i18n/phrases/i18n_want_to_watch_series';

import { utilities } from '~/common';
import { useConvertedContentFrom } from '~/src/common/sign-up/converted-content-from';
import { useLocale } from '~/src/components/LocaleProvider';
import {
  PaywallContentWithImage,
  InvalidMembership as _InvalidMembership,
  AnonymousPaywall,
  MultiViewPaywall,
  View,
} from '~/src/components/modals/paywalls';

import { ImageContainer } from './elements';
import { PromoImage } from '../../PromoImage';

const renderSeriesImages = () => (
  <div style={{ display: 'flex', justifyContent: 'center' }}>
    <ImageContainer>
      <PromoImage />
    </ImageContainer>
  </div>
);

const Anon =
  ({ returnUrl, locale }: { returnUrl: string; locale: Locale }): View =>
  setView => {
    return (
      <AnonymousPaywall
        heading={i18n_want_to_watch_series(locale)}
        subHeading={i18n_start_your_free_trial_to_watch(locale)}
        onClickSignIn={() => setView('SignIn')}
        renderImage={renderSeriesImages}
        returnUrl={returnUrl}
      />
    );
  };

const Free =
  ({ returnUrl, locale }: { returnUrl: string; locale: Locale }): View =>
  () => {
    return (
      <PaywallContentWithImage
        testId="article-basic-paywall-modal"
        heading={i18n_want_to_watch_series(locale)}
        subHeading={i18n_start_your_free_trial_to_watch(locale)}
        buttonText={i18n_try_free_for_x_days(locale, { days: '7' })}
        buttonUrl={returnUrl}
        buttonDataCampaign="basic_member_classes_paywall"
        renderImage={renderSeriesImages}
      />
    );
  };

const InvalidMembership = () => <_InvalidMembership />;

interface Props {
  onClose?: () => void;
  returnUrl: string;
}

export const SeriesPaywall: React.FC<Props> = ({ onClose, returnUrl }) => {
  const { locale } = useLocale();

  const { addToUrlConvertedContentFrom } = useConvertedContentFrom();

  const FreePaywall = useMemo(() => {
    const defaultSignupPath = utilities.getLocalizedDefaultSignupPath(locale, '/billing');
    const path = addToUrlConvertedContentFrom({
      returnUrl,
      targetUrl: defaultSignupPath,
    });

    return Free({ returnUrl: path, locale });
  }, [addToUrlConvertedContentFrom, locale, returnUrl]);

  const AnonPaywall = useMemo(() => {
    return Anon({ returnUrl, locale });
  }, [locale, returnUrl]);
  return (
    <MultiViewPaywall
      views={{ Free: FreePaywall, Anon: AnonPaywall, InvalidMembership }}
      onClose={onClose}
    />
  );
};
